import React from "react";
import Home from "resources/img/icons/admin/png/홈.png";
import OrderManage from "resources/img/icons/admin/png/주문관리.png";
import ProductManage from "resources/img/icons/admin/png/상품관리.png";
import CustomerManage from "resources/img/icons/admin/png/회원관리.png";
import Article from "resources/img/icons/admin/png/게시판.png";
import Promotion from "resources/img/icons/admin/png/프로모션.png";
import Statistic from "resources/img/icons/admin/png/통계.png";
import Message from "resources/img/icons/admin/png/메세지.png";
import Mobile from "resources/img/icons/admin/png/모바일.png";
import Web from "resources/img/icons/admin/png/웹.png";
import Alert from "resources/img/icons/admin/png/알림.png";
import Chat from "resources/img/icons/admin/png/채팅.png";
const AdminIcon = ({
  name,
  size = "24",
  width,
  height,
  color,
  className,
  style,
  ...props
}) => {
  const src = {
    home: Home,
    orderManage: OrderManage,
    productManage: ProductManage,
    customerManage: CustomerManage,
    article: Article,
    promotion: Promotion,
    statistic: Statistic,
    message: Message,
    web: Web,
    mobile: Mobile,
    alert: Alert,
    chat: Chat,
  }?.[name];
  return (
    <Icon
      src={src}
      width={width ? width : size}
      height={height ? height : size}
      color={color}
      style={style}
      className={className}
      props={props}
    />
  );
};

const Icon = ({ src, color, width, height, style, className, props }) => {
  return (
    <img
      src={src}
      className={className}
      style={{
        filter: color === "white" ? "invert(100%)" : null,
        width: width,
        height: height,
        ...style,
      }}
      alt="icon"
      {...props}
    />
  );
};
export default AdminIcon;
